var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclelock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FFEECC",
    stroke: "#C6C0B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 11H8.11111C7.49746 11 7 11.5698 7 12.2727V16.7273C7 17.4302 7.49746 18 8.11111 18H15.8889C16.5025 18 17 17.4302 17 16.7273V12.2727C17 11.5698 16.5025 11 15.8889 11Z",
    stroke: "#CBB893",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11V8.77778C9 8.04107 9.31607 7.33453 9.87868 6.81359C10.4413 6.29266 11.2044 6 12 6C12.7956 6 13.5587 6.29266 14.1213 6.81359C14.6839 7.33453 15 8.04107 15 8.77778V11",
    stroke: "#CBB893",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclelock);
export default __webpack_public_path__ + "static/media/circlelock.f92f377334ca01fbd32749da99d84eb4.svg";
export { ForwardRef as ReactComponent };